(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-movimiento-estatus-proyecto', {
            parent: 'entity',
            url: '/ss-movimiento-estatus-proyecto',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSMovimientoEstatusProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/s-s-movimiento-estatus-proyectos.html',
                    controller: 'SSMovimientoEstatusProyectoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-movimiento-estatus-proyecto-detail', {
            parent: 'ss-movimiento-estatus-proyecto',
            url: '/ss-movimiento-estatus-proyecto/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSMovimientoEstatusProyecto'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-detail.html',
                    controller: 'SSMovimientoEstatusProyectoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSMovimientoEstatusProyecto', function($stateParams, SSMovimientoEstatusProyecto) {
                    return SSMovimientoEstatusProyecto.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-movimiento-estatus-proyecto',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-movimiento-estatus-proyecto-detail.edit', {
            parent: 'ss-movimiento-estatus-proyecto-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-dialog.html',
                    controller: 'SSMovimientoEstatusProyectoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSMovimientoEstatusProyecto', function(SSMovimientoEstatusProyecto) {
                            return SSMovimientoEstatusProyecto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-movimiento-estatus-proyecto.new', {
            parent: 'ss-movimiento-estatus-proyecto',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-dialog.html',
                    controller: 'SSMovimientoEstatusProyectoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechaMovimiento: null,
                                estatusMovimiento: null,
                                observaciones: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-movimiento-estatus-proyecto', null, { reload: 'ss-movimiento-estatus-proyecto' });
                }, function() {
                    $state.go('ss-movimiento-estatus-proyecto');
                });
            }]
        })
        .state('ss-movimiento-estatus-proyecto.edit', {
            parent: 'ss-movimiento-estatus-proyecto',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-dialog.html',
                    controller: 'SSMovimientoEstatusProyectoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSMovimientoEstatusProyecto', function(SSMovimientoEstatusProyecto) {
                            return SSMovimientoEstatusProyecto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-movimiento-estatus-proyecto', null, { reload: 'ss-movimiento-estatus-proyecto' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-movimiento-estatus-proyecto.delete', {
            parent: 'ss-movimiento-estatus-proyecto',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-movimiento-estatus-proyecto/ss-movimiento-estatus-proyecto-delete-dialog.html',
                    controller: 'SSMovimientoEstatusProyectoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSMovimientoEstatusProyecto', function(SSMovimientoEstatusProyecto) {
                            return SSMovimientoEstatusProyecto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-movimiento-estatus-proyecto', null, { reload: 'ss-movimiento-estatus-proyecto' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
